module.exports = __webpack_public_path__ + "static/media/Group 1504@3x.f7097c0e.png";